<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card">
    <div class="card-body">
      <div class="row medidas-header-row">
        <div class="col-12 col-md-4">
          <div class="d-flex justify-content-start align-items-center">
            <label for="" class="col-form-label">{{ $t('weight') }}</label>
            <div class="ps-3">
              <input
                type="text"
                v-model="state.composicaoAtual.weight"
                class="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex justify-content-start align-items-center">
            <label for="" class="col-form-label">{{ $t('height') }}</label>
            <div class="ps-3">
              <money3
                v-bind="state.config"
                v-model="state.composicaoAtual.height"
                class="form-control form-control-sm"
              ></money3>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex justify-content-start align-items-center">
            <label class="col-form-label" for="">% {{ $t('fat') }}</label>
            <div class="ps-3">
              <money3
                v-bind="state.config"
                v-model="state.composicaoAtual.fat_percentage"
                @change="state.calcularMedidas = false"
                class="form-control form-control-sm"
              ></money3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 table-responsive">
          <!-- CHART OVERLAY -->
          <div v-if="showChart" class="chart-overlay" @click.self="showChart = false">
              <div class="chart-modal">
                  <div class="chart-modal-header">
                      <span><i class="fas fa-chart-bar me-2"></i>Gráfico de Dobras Cutâneas</span>
                      <button class="btn-chart-close" @click="showChart = false"><i class="fas fa-times"></i></button>
                  </div>
                  <div class="chart-modal-body">
                      <canvas ref="medidasChartCanvas"></canvas>
                  </div>
              </div>
          </div>

          <table class="table border table-striped text-center text-sm table-sm medidas-table">
            <thead>
              <tr class="font-weight-bold">
                <td class="text-start w-25">
                  {{ $t('measures') }}
                  <button class="btn-chart-toggle-sm ms-2" @click="showChart = !showChart" :title="showChart ? 'Esconder gráfico' : 'Ver gráfico'">
                    <i class="fas fa-chart-bar"></i>
                  </button>
                </td>
                <td class="text-start w-15">{{ $t('current') }}</td>
                <td class="w-15">{{ $t('first') }}</td>
                <td class="w-15">{{ $t('previous') }}</td>
                <td class="w-15">{{ $t('currentPrevious') }}</td>
                <td class="w-15">{{ $t('currentFirst') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-start">{{ $t('subscapular') }}</td>
                <td class="text-start">
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.sub_scapular"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.sub_scapular }}</td>
                <td>{{ state.composicaoAnterior.sub_scapular }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.sub_scapular - state.composicaoAnterior.sub_scapular)">
                  {{
                    state.composicaoAnterior.sub_scapular === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.sub_scapular -
                            state.composicaoAnterior.sub_scapular,
                        )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.sub_scapular - state.composicaoPrimeira.sub_scapular)">
                  {{
                    state.composicaoPrimeira.sub_scapular === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.sub_scapular -
                            state.composicaoPrimeira.sub_scapular,
                        )
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('triceps') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.triceps"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.triceps }}</td>
                <td>{{ state.composicaoAnterior.triceps }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.triceps - state.composicaoAnterior.triceps)">
                  {{
                    state.composicaoAnterior.triceps === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.triceps - state.composicaoAnterior.triceps)
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.triceps - state.composicaoPrimeira.triceps)">
                  {{
                    state.composicaoPrimeira.triceps === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.triceps - state.composicaoPrimeira.triceps)
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('chest') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.chest"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.chest }}</td>
                <td>{{ state.composicaoAnterior.chest }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.chest - state.composicaoAnterior.chest)">
                  {{
                    state.composicaoAnterior.chest === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.chest - state.composicaoAnterior.chest)
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.chest - state.composicaoPrimeira.chest)">
                  {{
                    state.composicaoPrimeira.chest === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.chest - state.composicaoPrimeira.chest)
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('midAxillary') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.mid_axillary"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.mid_axillary }}</td>
                <td>{{ state.composicaoAnterior.mid_axillary }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.mid_axillary - state.composicaoAnterior.mid_axillary)">
                  {{
                    state.composicaoAnterior.mid_axillary === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.mid_axillary -
                            state.composicaoAnterior.mid_axillary,
                        )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.mid_axillary - state.composicaoPrimeira.mid_axillary)">
                  {{
                    state.composicaoPrimeira.mid_axillary === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.mid_axillary -
                            state.composicaoPrimeira.mid_axillary,
                        )
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('suprailiac') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.suprailiac"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.suprailiac }}</td>
                <td>{{ state.composicaoAnterior.suprailiac }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.suprailiac - state.composicaoAnterior.suprailiac)">
                  {{
                    state.composicaoAnterior.suprailiac === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.suprailiac - state.composicaoAnterior.suprailiac,
                        )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.suprailiac - state.composicaoPrimeira.suprailiac)">
                  {{
                    state.composicaoPrimeira.suprailiac === 0
                      ? 0
                      : setSymbol(
                          state.composicaoAtual.suprailiac - state.composicaoPrimeira.suprailiac,
                        )
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('abdomen') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.abdomen"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.abdomen }}</td>
                <td>{{ state.composicaoAnterior.abdomen }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.abdomen - state.composicaoAnterior.abdomen)">
                  {{
                    state.composicaoAnterior.abdomen === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.abdomen - state.composicaoAnterior.abdomen)
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.abdomen - state.composicaoPrimeira.abdomen)">
                  {{
                    state.composicaoPrimeira.abdomen === 0
                      ? 0
                      : setSymbol(state.composicaoAtual.abdomen - state.composicaoPrimeira.abdomen)
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('thigh') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm medidas-input"
                    @keyup="state.calcularMedidas = true"
                    style="width: 55px"
                    v-model="state.composicaoAtual.thigh"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.thigh }}</td>
                <td>{{ state.composicaoAnterior.thigh }}</td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.thigh - state.composicaoAnterior.thigh)">
                  {{
                    state.composicaoAnterior.thigh === 0
                      ? 0
                      : setSymbol(
                          (state.composicaoAtual.thigh - state.composicaoAnterior.thigh).toFixed(2),
                        )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(state.composicaoAtual.thigh - state.composicaoPrimeira.thigh)">
                  {{
                    state.composicaoPrimeira.thigh === 0
                      ? 0
                      : setSymbol(
                          (state.composicaoAtual.thigh - state.composicaoPrimeira.thigh).toFixed(2),
                        )
                  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('total') }}</td>
                <td class="text-start">{{ somaAtual }}</td>
                <td>{{ somaPrimeiro }}</td>
                <td>{{ somaAnterior }}</td>
                <td><span :class="diffClass(somaAtual - somaAnterior)">{{ somaAnterior === 0 ? 0 : setSymbol(somaAtual - somaAnterior) }}</span></td>
                <td><span :class="diffClass(somaAtual - somaPrimeiro)">{{ somaPrimeiro === 0 ? 0 : setSymbol(somaAtual - somaPrimeiro) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12">
          <resultados-component
            v-if="state.displayResult"
            :calculaMedidasProp="state.calcularMedidas"
            :medidaAtualProp="state.composicaoAtual"
            :medidaAnteriorProp="state.composicaoAnterior"
            :medidaPrimeiraProp="state.composicaoPrimeira"
          />
        </div>
        <div class="col-12 text-end">
          <router-link to="/avaliacao-fisica">
            <button type="button" class="btn bg-gradient-secondary">
              {{ $t('back') }}
            </button>
          </router-link>
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import composicaoCorporalRepository from '../../../../../services/api/composicaoCorporalRepository'
import { useRouter, useRoute } from 'vue-router'
import ComposiaoCorporalModel from '@/models/composicaoCorporalModel'
import ResultadosComponent from './ResultadosComponent.vue'
import { Money3Component } from 'v-money3'
import Chart from 'chart.js/auto'
import {
  fatWeight,
  imc,
  mmMetabolicRate,
  percentageBodyFatPollock,
  skinnyWeight,
} from '@/services/composicaoCorporal.service'
import * as composicaoCorporal from '@/services/composicaoCorporal.service'

export default {
  components: {
    ResultadosComponent,
    money3: Money3Component,
  },
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      state.avaliacaoId = props.avaliacaoIdProp
      buscarDados()
    })

    const state = reactive({
      calcularMedidas: false,
      avaliacaoId: 0,
      composicaoAtual: new ComposiaoCorporalModel(),
      composicaoAnterior: new ComposiaoCorporalModel(),
      composicaoPrimeira: new ComposiaoCorporalModel(),
      config: {
        masked: false,
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: false,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
        displayResult: false,
      },
    })

    function setSymbol(value) {
      if (parseFloat(value) > 0) {
        return `+ ${value}`
      }
    }

    function diffClass(value) {
      const num = parseFloat(value)
      if (isNaN(num) || num === 0) return 'diff-zero'
      return num > 0 ? 'diff-positive' : 'diff-negative'
    }

    async function buscarDados() {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        if (state.avaliacaoId == 0) {
          let responseFirst = await composicaoCorporalRepository.ComposicaoCorporalGetFirst()
          let responseLast = await composicaoCorporalRepository.ComposicaoCorporalGetLatest()
          store.commit('SET_SPLASH_SCREEN', false)

          if (responseFirst.data.success && responseFirst.data.data != null) {
            state.composicaoPrimeira = responseFirst.data.data
          }
          if (responseLast.data.success && responseLast.data.data != null) {
            state.composicaoAnterior = responseLast.data.data
          }
        } else {
          let response = await composicaoCorporalRepository.ComposicaoGetByAssessmentId(
            state.avaliacaoId,
          )
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            if (response.data.data.item != null) {
              state.composicaoAtual = Object.assign(
                new ComposiaoCorporalModel(),
                response.data.data.item,
              )
              if (parseFloat(state.composicaoAtual.sub_scapular) > 0) {
                state.calcularMedidas = true
              }
            }
            if (response.data.data.before != null) {
              state.composicaoAnterior = Object.assign(
                new ComposiaoCorporalModel(),
                response.data.data.before,
              )
            }
            if (response.data.data.first != null) {
              state.composicaoPrimeira = Object.assign(
                new ComposiaoCorporalModel(),
                response.data.data.first,
              )
            }
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        state.displayResult = true
      }
    }

    const atualPreenchido = computed(() => {
      return (
        parseInt(state.composicaoAtual.sub_scapular) > 0 &&
        parseInt(state.composicaoAtual.triceps) > 0 &&
        parseInt(state.composicaoAtual.chest) > 0 &&
        parseInt(state.composicaoAtual.mid_axillary) > 0 &&
        parseInt(state.composicaoAtual.suprailiac) > 0 &&
        parseInt(state.composicaoAtual.abdomen) > 0 &&
        parseInt(state.composicaoAtual.thigh) > 0
      )
    })

    const somaAtual = computed(() => {
      const valores = [
        state.composicaoAtual.sub_scapular,
        state.composicaoAtual.triceps,
        state.composicaoAtual.chest,
        state.composicaoAtual.mid_axillary,
        state.composicaoAtual.suprailiac,
        state.composicaoAtual.abdomen,
        state.composicaoAtual.thigh,
      ].map((val) => parseInt(val))

      const todasMaioresQueZero = valores.every((v) => v > 0)
      console.log('todasMaioresQueZero aaaaaaa')
      console.log(todasMaioresQueZero)
      return todasMaioresQueZero ? valores.reduce((a, b) => a + b, 0) : 0
      /*const response = parseInt(state.composicaoAtual.sub_scapular) +
          parseInt(state.composicaoAtual.triceps) +
          parseInt(state.composicaoAtual.biceps) +
          parseInt(state.composicaoAtual.chest) +
          parseInt(state.composicaoAtual.mid_axillary) +
          parseInt(state.composicaoAtual.suprailiac) +
          parseInt(state.composicaoAtual.abdomen) +
          parseInt(state.composicaoAtual.thigh) +
          parseInt(state.composicaoAtual.leg)
    return isNaN(response) ? 0 : response*/
    })

    /*const somaPrimeiro = computed (() => {
    const response = parseInt(state.composicaoPrimeira.sub_scapular) +
        parseInt(state.composicaoPrimeira.triceps) +
        parseInt(state.composicaoPrimeira.biceps) +
        parseInt(state.composicaoPrimeira.chest) +
        parseInt(state.composicaoPrimeira.mid_axillary) +
        parseInt(state.composicaoPrimeira.suprailiac) +
        parseInt(state.composicaoPrimeira.abdomen) +
        parseInt(state.composicaoPrimeira.thigh) +
        parseInt(state.composicaoPrimeira.leg)
    return isNaN(response) ? 0 : response
  })*/
    const somaPrimeiro = computed(() => {
      const valores = [
        state.composicaoPrimeira.sub_scapular,
        state.composicaoPrimeira.triceps,
        state.composicaoPrimeira.chest,
        state.composicaoPrimeira.mid_axillary,
        state.composicaoPrimeira.suprailiac,
        state.composicaoPrimeira.abdomen,
        state.composicaoPrimeira.thigh,
      ].map((val) => parseInt(val))

      const todasMaioresQueZero = valores.every((v) => !isNaN(v) && v > 0)
      console.log('todasMaioresQueZero')
      console.log(todasMaioresQueZero)
      if (todasMaioresQueZero) {
        const response = valores.reduce((a, b) => a + b, 0)
        console.log('response')
        console.log(response)
        if (response === 'NaN') {
          return 0
        }
        return response
      }
      return 0
    })

    /*const somaAnterior = computed (() => {
      return parseInt(state.composicaoAnterior.sub_scapular) +
          parseInt(state.composicaoAnterior.triceps) +
          parseInt(state.composicaoAnterior.biceps) +
          parseInt(state.composicaoAnterior.chest) +
          parseInt(state.composicaoAnterior.mid_axillary) +
          parseInt(state.composicaoAnterior.suprailiac) +
          parseInt(state.composicaoAnterior.abdomen) +
          parseInt(state.composicaoAnterior.thigh) +
          parseInt(state.composicaoAnterior.leg)
  })*/
    const somaAnterior = computed(() => {
      const valores = [
        state.composicaoAnterior.sub_scapular,
        state.composicaoAnterior.triceps,
        state.composicaoAnterior.chest,
        state.composicaoAnterior.mid_axillary,
        state.composicaoAnterior.suprailiac,
        state.composicaoAnterior.abdomen,
        state.composicaoAnterior.thigh,
      ].map((val) => parseInt(val))

      const todasMaioresQueZero = valores.every((v) => !isNaN(v) && v > 0)
      console.log('todasMaioresQueZero')
      console.log(todasMaioresQueZero)
      if (todasMaioresQueZero) {
        const response = valores.reduce((a, b) => a + b, 0)
        console.log('response')
        console.log(response)
        if (response === 'NaN') {
          return 0
        }
        return response
      }
      return 0
    })

    watch(state.composicaoAtual, (newValue, oldValue) => {
      console.log(oldValue)
      console.log(newValue)
      console.log(state.composicaoAtual)
      fatPercentageAtual()
    })

    function fatPercentageAtual() {
      state.composicaoAtual.fat_percentage = composicaoCorporal.percentageBodyFatPollock(
        state.composicaoAtual.age,
        somaAtual.value,
      )
    }

    function salvar() {
      try {
        if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
          state.avaliacaoId = parseInt(route.params.id)
        }
        store.commit('SET_SPLASH_SCREEN', true)

        // Normaliza numeros (aceita virgula "66,10" -> 66.10) antes de calcular/salvar.
        // Evita NaN nos resultados e salva os valores corretos no banco.
        const camposNum = ['weight', 'height', 'fat_percentage', 'sub_scapular', 'triceps',
          'biceps', 'chest', 'mid_axillary', 'suprailiac', 'abdomen', 'thigh', 'leg']
        camposNum.forEach((k) => {
          state.composicaoAtual[k] = composicaoCorporal.n(state.composicaoAtual[k])
        })

        state.composicaoAtual.imc = composicaoCorporal.imc(
          state.composicaoAtual.weight,
          state.composicaoAtual.height,
        )
        console.log(state.composicaoAtual.age)
        console.log(somaAtual.value)

        console.log(state.composicaoAtual.fat_percentage)
        state.composicaoAtual.skinny_weight = composicaoCorporal.skinnyWeight(
          state.composicaoAtual.weight,
          composicaoCorporal.fatWeight(
            state.composicaoAtual.weight,
            state.composicaoAtual.fat_percentage,
          ),
        )

        if (state.avaliacaoId == 0) {
          context.emit('salvar', state.composicaoAtual, 'medidas')
        } else {
          state.composicaoAtual.student_physical_assessment_id = state.avaliacaoId
          if (state.composicaoAtual.id == undefined || state.composicaoAtual.id == 0) {
            composicaoCorporalRepository
              .ComposicaoCorporalPost(state.composicaoAtual)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)
                console.log(response)
                if (response.data.success) {
                  swal({
                    title: 'Composição corporal',
                    text: 'Composição corporal cadastrada com sucesso!',
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  })
                }
              })
          } else {
            composicaoCorporalRepository
              .ComposicaoCorporalPut(state.composicaoAtual.id, state.composicaoAtual)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)
                console.log(response)
                if (response.data.success) {
                  swal({
                    title: 'Composição corporal',
                    text: 'Composição corporal cadastrada com sucesso!',
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  })
                }
              })
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const showChart = ref(false)
    const medidasChartCanvas = ref(null)
    let chartInstance = null

    watch(showChart, async (val) => {
      if (val) {
        await nextTick()
        renderMedidasChart()
      } else {
        if (chartInstance) {
          chartInstance.destroy()
          chartInstance = null
        }
      }
    })

    function renderMedidasChart() {
      if (!medidasChartCanvas.value) return
      if (chartInstance) chartInstance.destroy()
      const ctx = medidasChartCanvas.value.getContext('2d')
      const fields = [
        { key: 'sub_scapular', label: 'Subescapular' },
        { key: 'triceps', label: 'Tríceps' },
        { key: 'chest', label: 'Peitoral' },
        { key: 'mid_axillary', label: 'Axilar Média' },
        { key: 'suprailiac', label: 'Suprailíaca' },
        { key: 'abdomen', label: 'Abdômen' },
        { key: 'thigh', label: 'Coxa' },
      ]
      const labels = fields.map(f => f.label)
      const dataAtual = fields.map(f => parseFloat(state.composicaoAtual[f.key]) || 0)
      const dataPrimeira = fields.map(f => parseFloat(state.composicaoPrimeira[f.key]) || 0)
      const dataAnterior = fields.map(f => parseFloat(state.composicaoAnterior[f.key]) || 0)

      chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            { label: 'Atual', data: dataAtual, backgroundColor: '#F7941D', borderColor: '#F7941D', borderWidth: 2, borderRadius: 5 },
            { label: 'Primeira', data: dataPrimeira, backgroundColor: '#2D3A7C', borderColor: '#2D3A7C', borderWidth: 2, borderRadius: 5 },
            { label: 'Anterior', data: dataAnterior, backgroundColor: '#7B8ABF', borderColor: '#7B8ABF', borderWidth: 2, borderRadius: 5 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { size: 12, weight: 'bold' }, padding: 14, usePointStyle: true, pointStyle: 'circle' } },
            tooltip: { backgroundColor: '#2D3A7C', cornerRadius: 8, padding: 10 }
          },
          scales: {
            y: { beginAtZero: true, grid: { color: 'rgba(45,58,124,0.08)' }, ticks: { font: { size: 11 }, color: '#344767' } },
            x: { grid: { display: false }, ticks: { font: { size: 10, weight: 'bold' }, color: '#2D3A7C' } }
          }
        }
      })
    }

    return {
      state,
      salvar,
      atualPreenchido,
      somaAtual,
      somaPrimeiro,
      somaAnterior,
      setSymbol,
      diffClass,
      showChart,
      medidasChartCanvas,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.medidas-header-row {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
}
.medidas-header-row label {
  font-weight: 600;
  color: #fff;
  font-size: 0.85rem;
}
.medidas-header-row .form-control-sm {
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.9rem;
  color: #344767;
  background: rgba(255,255,255,0.95);
}
.medidas-header-row .form-control-sm:focus {
  border-color: #F7941D;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.25);
}
.medidas-table thead td,
.medidas-table thead th {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 8px;
  border-color: #354585 !important;
}
.medidas-table tbody td {
  padding: 8px 8px;
  vertical-align: middle;
  color: #344767;
  font-size: 0.85rem;
}
.medidas-table tbody td.text-start {
  font-weight: 600;
  color: #2D3A7C;
}
.medidas-table tbody tr:nth-child(even) {
  background: #f0f2f7;
}
.medidas-table tbody tr:nth-child(odd) {
  background: #fff;
}
.medidas-table tbody tr:hover {
  background: #ebeff5;
}
.medidas-table tbody tr:last-child {
  background: linear-gradient(135deg, #edf0f6 0%, #e4e8f0 100%) !important;
  font-weight: 700;
}
.medidas-table tbody tr:last-child td {
  color: #2D3A7C;
  font-weight: 700;
  border-top: 2px solid #c8cedf;
}
.medidas-input {
  border: 2px solid #2D3A7C !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  color: #2D3A7C !important;
  text-align: center;
  width: 60px !important;
  background: #edf0f6 !important;
  transition: all 0.2s;
}
.medidas-input:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.2) !important;
  background: #fff !important;
}
.diff-positive {
  display: inline-block;
  background: rgba(45, 206, 137, 0.12);
  color: #2dce89;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
.diff-negative {
  display: inline-block;
  background: rgba(245, 54, 92, 0.1);
  color: #f5365c;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
.diff-zero {
  display: inline-block;
  background: rgba(131, 146, 171, 0.1);
  color: #8392ab;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
/* Chart button inline */
.btn-chart-toggle-sm {
  background: #F7941D;
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  vertical-align: middle;
  box-shadow: 0 2px 6px rgba(247,148,29,0.3);
}
.btn-chart-toggle-sm:hover {
  background: #e5850f;
  transform: scale(1.1);
}
/* Chart overlay/modal */
.chart-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.chart-modal {
  background: #fff;
  border-radius: 16px;
  width: 92%;
  max-width: 850px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  overflow: hidden;
  animation: chartSlideIn 0.3s ease;
}
@keyframes chartSlideIn {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.chart-modal-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-chart-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-chart-close:hover {
  background: #F7941D;
}
.chart-modal-body {
  padding: 24px;
  height: 420px;
}
</style>
